<script setup lang="ts">
import { ScrollAreaScrollbar, type ScrollAreaScrollbarProps, ScrollAreaThumb } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'
import { cn } from '@/components/utils'

const props = withDefaults(defineProps<ScrollAreaScrollbarProps & { class?: HTMLAttributes['class'] }>(), {
  orientation: 'vertical'
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <ScrollAreaScrollbar
    v-bind="delegatedProps"
    :class="
      cn(
        'flex touch-none select-none transition-colors',
        orientation === 'vertical' && 'h-full w-2 border-l border-l-transparent p-px max-lg:w-1.5',
        orientation === 'horizontal' && 'h-2 flex-col border-t border-t-transparent p-px max-lg:h-1.5',
        props.class
      )
    "
  >
    <ScrollAreaThumb class="relative flex-1 rounded-none bg-dark-background" />
  </ScrollAreaScrollbar>
</template>
